import { useEffect, useRef, useState } from 'react'

export function Metric({ value, label }) {
  return (
    <div className="metric">
      <strong>{value}</strong>
      <span>{label}</span>
    </div>
  )
}

export default function StorySection({
  id,
  index,
  eyebrow,
  title,
  children,
  align = 'left',
  theme = 'dark',
  className = '',
}) {
  const ref = useRef(null)
  const [visible, setVisible] = useState(index === 0)

  useEffect(() => {
    const node = ref.current
    if (!node) return undefined

    const observer = new IntersectionObserver(
      ([entry]) => setVisible(entry.isIntersecting),
      { rootMargin: '-18% 0px -18% 0px', threshold: 0.08 },
    )
    observer.observe(node)
    return () => observer.disconnect()
  }, [])

  return (
    <section
      ref={ref}
      id={id}
      data-scene
      data-theme={theme}
      className={`story-section story-section--${align} story-section--${theme} ${
        visible ? 'is-visible' : ''
      } ${className}`}
    >
      <div className="story-section__content">
        <p className="eyebrow reveal-item">
          <span>{String(index + 1).padStart(2, '0')}</span>
          {eyebrow}
        </p>
        <h2 className="reveal-item">{title}</h2>
        <div className="story-section__body reveal-item">{children}</div>
      </div>
    </section>
  )
}
